/**
 * A debounced write, flushed rather than dropped: it carries the values it was scheduled with.
 * One write at a time, so two snapshots of the same form cannot reach the server out of order, and
 * `flush` resolves once the scheduled write and the one in flight are both done. Pure module — the
 * appeal's fields and its cover sheet write the same appeal and share this one queue shape.
 */
export function debouncedWrite(delayMs) {
    let timer = null;
    let pending = null;
    let queue = Promise.resolve();
    const flush = () => {
        if (timer)
            clearTimeout(timer);
        timer = null;
        const write = pending;
        pending = null;
        if (write)
            queue = queue.then(() => write()).catch(() => undefined);
        return queue;
    };
    return {
        schedule(write) {
            if (timer)
                clearTimeout(timer);
            pending = write;
            timer = setTimeout(flush, delayMs);
        },
        cancel() {
            if (timer)
                clearTimeout(timer);
            timer = null;
            pending = null;
        },
        flush,
    };
}
